import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import InstallationIntegration from "../../components/installation-integration";

function InstallationIntegrationPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          Precision Installation, Integration & Commissioning Services for
          Aviation | GGAS
        </title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb
        title={
          "Precision Installation, Integration & Commissioning Services for Aviation"
        }
        t={t}
      />
      <InstallationIntegration />
    </>
  );
}

export default InstallationIntegrationPage;
